import { useContext } from 'react';
import MessagesConext, { MessagesContextType } from './messages-context';

export default function useMessages(): MessagesContextType {
  return useContext(MessagesConext);
}
